import { FC } from "react";
import bgImage from "../../Assets/homev2/ap-bg.png";
import image from "../../Assets/homev2/ap-image.png";
import ContainedButton from "./Buttons/Contained";

const AdvantagePlan: FC = () => {
  return (
    <section
      className="w-full bg-cover bg-no-repeat bg-bottom overflow-hidden max-h-[911px] relative"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="w-full h-full max-w-[1500px] mx-auto px-4 pt-12 md:pt-20 flex flex-col justify-between items-center">
        <div className="w-full">
          <h2 className="text-3xl md:text-5xl lg:text-7xl text-black font-semibold text-center flex items-baseline justify-center">
            Ad
            <svg
              className="w-[34px] h-[23px] md:w-[45px] md:h-[34px] lg:w-[56px] lg:h-[45px] "
              viewBox="0 0 56 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.0828 22.3015H0L12.0059 41.9301C12.8834 43.3613 14.2395 44.3427 15.7951 44.7108L20.8607 35.6326L13.0828 22.3015Z"
                fill="black"
              />
              <mask
                id="mask0_15_170"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="16"
                y="44"
                width="10"
                height="1"
              >
                <path
                  d="M17.2282 44.874H25.9634L16.3906 44.8331C16.6698 44.874 16.949 44.874 17.2282 44.874Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_15_170)">
                <path
                  d="M26.0025 44.8331H16.4297V44.874H26.0025V44.8331Z"
                  fill="url(#paint0_linear_15_170)"
                />
              </g>
              <mask
                id="mask1_15_170"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="15"
                y="44"
                width="2"
                height="1"
              >
                <path
                  d="M15.7578 44.8329H16.4359C16.2365 44.792 16.037 44.7511 15.8376 44.7102L15.7578 44.8329Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_15_170)">
                <path
                  d="M16.4359 44.7102H15.7578V44.8329H16.4359V44.7102Z"
                  fill="url(#paint1_linear_15_170)"
                />
              </g>
              <mask
                id="mask2_15_170"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="15"
                y="35"
                width="11"
                height="10"
              >
                <path
                  d="M15.7967 44.7098C15.9962 44.7507 16.1956 44.7916 16.395 44.8325L25.9678 44.8734L20.8623 35.6316L15.7967 44.7098Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask2_15_170)">
                <path
                  d="M25.9677 35.6316H15.7966V44.8734H25.9677V35.6316Z"
                  fill="black"
                />
              </g>
              <mask
                id="mask3_15_170"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="15"
                y="35"
                width="11"
                height="10"
              >
                <path
                  d="M15.7967 44.7098C15.9962 44.7507 16.1956 44.7916 16.395 44.8325L25.9678 44.8734L20.8623 35.6316L15.7967 44.7098Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask3_15_170)">
                <path
                  d="M25.9677 35.6316H15.7966V44.8734H25.9677V35.6316Z"
                  fill="black"
                />
              </g>
              <mask
                id="mask4_15_170"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="20"
                y="35"
                width="7"
                height="10"
              >
                <path
                  d="M26.0008 44.8734L20.8555 35.6316L26.0008 44.8734Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask4_15_170)">
                <path
                  d="M26.0008 35.6316H20.8555V44.8734H26.0008V35.6316Z"
                  fill="black"
                />
              </g>
              <mask
                id="mask5_15_170"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="20"
                y="0"
                width="36"
                height="36"
              >
                <path
                  d="M44.9869 0.873657C42.6735 0.873657 41.0381 1.93687 40.0409 3.94062L25.4823 27.9856L20.8555 35.6325H33.8186L55.9956 0.873657H44.9869Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask5_15_170)">
                <path
                  d="M55.9956 0.873657H20.8555V35.6325H55.9956V0.873657Z"
                  fill="url(#paint2_linear_15_170)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_15_170"
                  x1="16.4142"
                  y1="44.8428"
                  x2="25.9846"
                  y2="44.8428"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3BB54A" />
                  <stop offset="0.0818011" stop-color="#6ABD45" />
                  <stop offset="0.1853" stop-color="#8DC63F" />
                  <stop offset="0.2979" stop-color="#A7CE39" />
                  <stop offset="0.4209" stop-color="#BBD533" />
                  <stop offset="0.5594" stop-color="#C9D92D" />
                  <stop offset="0.7265" stop-color="#D1DC29" />
                  <stop offset="1" stop-color="#D3DD28" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_15_170"
                  x1="15.7487"
                  y1="44.7653"
                  x2="16.4237"
                  y2="44.7653"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3BB54A" />
                  <stop offset="0.0818011" stop-color="#6ABD45" />
                  <stop offset="0.1853" stop-color="#8DC63F" />
                  <stop offset="0.2979" stop-color="#A7CE39" />
                  <stop offset="0.4209" stop-color="#BBD533" />
                  <stop offset="0.5594" stop-color="#C9D92D" />
                  <stop offset="0.7265" stop-color="#D1DC29" />
                  <stop offset="1" stop-color="#D3DD28" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_15_170"
                  x1="20.8419"
                  y1="18.2382"
                  x2="55.9738"
                  y2="18.2382"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3BB54A" />
                  <stop offset="0.0818011" stop-color="#6ABD45" />
                  <stop offset="0.1853" stop-color="#8DC63F" />
                  <stop offset="0.2979" stop-color="#A7CE39" />
                  <stop offset="0.4209" stop-color="#BBD533" />
                  <stop offset="0.5594" stop-color="#C9D92D" />
                  <stop offset="0.7265" stop-color="#D1DC29" />
                  <stop offset="1" stop-color="#D3DD28" />
                </linearGradient>
              </defs>
            </svg>
            antage Plan
          </h2>
          <h4 className="text-center text-black md:text-2xl mt-4">
            Member rewards. Benefits & discounts.
          </h4>
          <div className="flex items-center w-[60%] max-w-[180px] md:max-w-max gap-4 md:gap-6 md:w-max mx-auto mt-2 md:mt-10">
            <a href="https://salesboxmarket.myshopify.com/" className="w-full">
              <ContainedButton>Sign Up</ContainedButton>
            </a>
          </div>
        </div>
        <div className="w-full mt-14 lg:w-auto">
          <img
            src={image}
            alt="Advantage Card"
            width="100%"
            height="100%"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default AdvantagePlan;
